module.exports = __webpack_public_path__ + "static/bootstrap-card-footer-089de4ce54e108dff9de613c6d629dc2.png";